import { render, staticRenderFns } from "./FormHandler.vue?vue&type=template&id=25a11335"
import script from "./FormHandler.vue?vue&type=script&lang=js"
export * from "./FormHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports